import { gql } from 'apollo-boost'

export const SYNC_PROFILE = gql`
  mutation syncProfile($data: userForChatSync) {
    syncProfile(data: $data)
  }
`

